import { isValidCEP } from '../../../../utils/validation';
import type { ShippingAddressData } from '../../../../types';
import type { ShippingAddressFormState } from '../types/shipping-address.types';

export function validateShippingAddress(state: ShippingAddressFormState): Partial<ShippingAddressData> {
  const { formData, isCepValidAndFound } = state;
  const errors: Partial<ShippingAddressData> = {};
  
  // CEP validation
  if (!formData.zipCode.trim()) {
    errors.zipCode = 'CEP é obrigatório.';
  } else if (!isValidCEP(formData.zipCode)) {
    errors.zipCode = 'CEP inválido.';
  } else if (!isCepValidAndFound) {
    errors.zipCode = 'CEP inválido';
  }
  
  // Only validate other fields if CEP is valid and found
  if (isCepValidAndFound) {
    if (!formData.street.trim()) {
      errors.street = 'Endereço é obrigatório.';
    }
    if (!formData.number.trim()) {
      errors.number = 'Número é obrigatório.';
    }
    if (!formData.neighborhood.trim()) {
      errors.neighborhood = 'Bairro é obrigatório.';
    }
  }

  return errors;
}

export function isFieldValid(value: string, isCepValidAndFound: boolean = true): boolean {
  return value.trim().length > 0 && isCepValidAndFound;
} 